import { factory } from './model/model';
import { TodoList as View } from './ui/TodoList';

export { getComponentByTodoType } from './lib/getComponentByTodoType';
export { AdaptationFeedbackTodo } from './ui/AdaptationFeedbackTodo';
export { DefaultTodoItem } from './ui/DefaultTodoItem';
export { TodoItemContent } from './ui/TodoItemContent';
export { TodoListItem } from './ui/TodoListItem';
export { TodoListItemForContest } from './ui/TodoListItemForContest';
export { getCurrentTodosFx } from './model/effects';

export const TodoList = {
  factory,
  View,
};
